<template>
  <v-card
    class="max-shadow"
    @click="$emit('click', booking)"
  >
    <v-card-title class="px-1">
      <v-container
        grid-list-xs
        class="pa-0"
      >
        <v-layout
          column
          wrap
          class="px-3"
        >
          <v-container
            grid-list-md
            class="py-0 px-1"
          >
            <v-layout
              row
              wrap
              align-center
              justify-space-between
            >
              <span class="subheading font-weight-medium">{{ event.title }}</span>
              <span>{{ formatTime(booking.bookedDate) }}</span>
            </v-layout>
          </v-container>
          <span class="caption pt-1">{{ event.description }}</span>
          <span> {{ formatDuration(event.startDate, event.endDate) }}</span>
          <span>
            <v-icon small>place</v-icon>
            {{ booking.facility.name }}
          </span>
        </v-layout>
      </v-container>
    </v-card-title>
    <v-card-actions class="pt-0">
      <v-list
        class="grow pa-0"
        style="background-color: inherit"
      >
        <v-list-tile>
          <v-list-tile-avatar>
            <avatar
              :text="bookedBy.name"
              :size="32"
              :src="bookedBy.photo"
            />
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-sub-title>Booked By</v-list-tile-sub-title>
            <v-list-tile-title class="font-weight-medium">
              {{ booking.bookedBy.name }}
            </v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action :class="getStatusColor(booking.status)">
            <span>{{ booking.status }}</span>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-card-actions>
  </v-card>
</template>
<script>
import * as moment from 'moment';
import _get from 'lodash/get';
import Avatar from '@/components/common/Avatar';
export default {
  components: {
    avatar: Avatar
  },
  props: {
    booking: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    event() {
      return _get(this.booking, 'event');
    },
    bookedBy() {
      return _get(this.booking, 'bookedBy');
    }
  },
  methods: {
    getStatusColor(status) {
      return status === 'cancelled'
        ? 'red--text subheading'
        : 'green--text subheading';
    },
    formatTime(timestamp) {
      const date = timestamp.toDate();
      const today = moment().startOf('day');
      return moment(date).isAfter(today)
        ? moment(date).fromNow()
        : moment(date).calendar(today, {
            lastWeek: 'D MMM [at] hh:mm A',
            sameElse: 'D MMM [at] hh:mm A'
          });
    },
    formatDuration(st, en) {
      if (st === undefined || en === undefined) return;
      const start = st.toDate();
      const end = en.toDate();
      const startDate = moment(start).format('YYYY-MM-DD');
      const endDate = moment(end).format('YYYY-MM-DD');
      const sameDay = moment(startDate).isSame(endDate);
      const startTime =
        moment(start).minutes() === 0
          ? moment(start).format('ha')
          : moment(start).format('h:ma');
      const endTime =
        moment(end).minutes() === 0
          ? moment(end).format('ha')
          : moment(end).format('h:ma');
      if (sameDay) {
        return `${moment(start).format(
          'ddd MMM DD, YYYY'
        )} ${startTime} - ${endTime}`;
      } else {
        return `${moment(start).format(
          'ddd MMM DD, YYYY'
        )} ${startTime} - ${moment(end).format('ddd MMM DD, YYYY')} ${endTime}`;
      }
    }
  }
};
</script>
